module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Bold-8ce7b9e67a6b7cd8c6d71b084095ddf8.woff2";